import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { d as defineCustomElement$1 } from './mapy-loader3.js';
import { E as getStructuredReviewData, F as getStarsFromStructuredItems, g as getLocale, z as classNames, k as getTheme } from './utils2.js';
import { d as DIALOG_PAGES, e as STRUCTURED_MEDIAN, j as STARS_SIZE } from './const.js';
import { d as defineCustomElement$a } from './mapy-icon2.js';
import { d as defineCustomElement$9 } from './mapy-loader2.js';
import { d as defineCustomElement$8 } from './mapy-review-button2.js';
import { d as defineCustomElement$7 } from './mapy-review-dialog-footer2.js';
import { d as defineCustomElement$6 } from './mapy-review-stars2.js';
import { d as defineCustomElement$5 } from './mapy-review-structured-review2.js';
import { d as defineCustomElement$4 } from './mapy-review-structured-review-item2.js';
import { d as defineCustomElement$3 } from './mapy-review-tooltip2.js';
import { d as defineCustomElement$2 } from './mapy-review-user2.js';

const mapyReviewDialogPageStarsStructuredCss = ".mapy-review-dialog-page-stars-structured{padding:48px 32px 0 32px;display:flex;flex-direction:column;gap:24px;justify-content:space-between;height:100%;box-sizing:border-box;font-family:Arial;align-items:center;position:relative}.header{display:flex;gap:8px;flex-direction:column;align-items:center;justify-content:center;width:100%}.header .title{margin:0;font-size:20px;font-style:normal;font-weight:700;line-height:28px}.structuredReview{display:flex;width:100%;padding:0 16px;box-sizing:border-box}.structuredReview mapy-review-structured-review{width:100%;flex:1}.stars-area.has-loader{position:relative}.stars-area .areaLoader{position:absolute;left:50%;transform:translateX(-50%);margin-top:8px}mapy-review-dialog-footer{width:100%}.mapy-review-dialog-page-stars-structured[data-theme=\"firmy\"] .structuredReview{flex:0 1 auto}@media only screen and (max-height: 529px){.mapy-review-dialog-page-stars-structured{overflow:auto}}@media only screen and (max-width: 500px){.mapy-review-dialog-page-stars-structured{padding:24px 16px 0 16px}.structuredReview{padding:0}}";
const MapyReviewDialogPageStarsStructuredStyle0 = mapyReviewDialogPageStarsStructuredCss;

var __classPrivateFieldSet = (undefined && undefined.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m")
        throw new TypeError("Private method is not writable");
    if (kind === "a" && !f)
        throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver))
        throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (undefined && undefined.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f)
        throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver))
        throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _MapyReviewDialogPageStarsStructured_structuredData, _MapyReviewDialogPageStarsStructured_wasStarsClick, _MapyReviewDialogPageStarsStructured_lang;
defineCustomElement$1();
const MapyReviewDialogPageStarsStructured = /*@__PURE__*/ proxyCustomElement(class MapyReviewDialogPageStarsStructured extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.signal = createEvent(this, "signal", 1);
        this.save = createEvent(this, "save", 1);
        _MapyReviewDialogPageStarsStructured_structuredData.set(this, []);
        _MapyReviewDialogPageStarsStructured_wasStarsClick.set(this, false);
        _MapyReviewDialogPageStarsStructured_lang.set(this, "");
        this.onStarsChange = (event) => {
            event.stopPropagation();
            __classPrivateFieldSet(this, _MapyReviewDialogPageStarsStructured_wasStarsClick, true, "f");
            // @ts-ignore
            this.curRating = event.target.value;
            this.signal.emit({
                name: "stars-click",
                rating: this.curRating,
            });
            if (!this.hasButton) {
                this.onSave();
            }
        };
        this.onSignal = (signal) => {
            this.signal.emit(signal.detail);
        };
        this.onFooterSave = () => {
            this.onSave();
        };
        this.onSave = () => {
            let structuredRating = [];
            if (this.structuredItems.length > 0) {
                structuredRating = __classPrivateFieldGet(this, _MapyReviewDialogPageStarsStructured_structuredData, "f").length > 0
                    ? __classPrivateFieldGet(this, _MapyReviewDialogPageStarsStructured_structuredData, "f")
                    : getStructuredReviewData(this.structuredItems);
            }
            this.save.emit({
                page: DIALOG_PAGES.STARS_STRUCTURED,
                rating: this.curRating,
                structuredRating,
            });
        };
        this.onStructuredItemsChange = (event) => {
            __classPrivateFieldSet(this, _MapyReviewDialogPageStarsStructured_structuredData, event.detail.items, "f");
            this.signal.emit({
                name: "structured-review",
                data: __classPrivateFieldGet(this, _MapyReviewDialogPageStarsStructured_structuredData, "f"),
            });
            if (!__classPrivateFieldGet(this, _MapyReviewDialogPageStarsStructured_wasStarsClick, "f")) {
                this.curRating = getStarsFromStructuredItems(this.structuredMedian, __classPrivateFieldGet(this, _MapyReviewDialogPageStarsStructured_structuredData, "f"));
            }
        };
        this.user = "";
        this.verifiedUser = false;
        this.poiTitle = "";
        this.isFirm = false;
        this.hasButton = false;
        this.rating = 0;
        this.error = "";
        this.loading = false;
        this.switchStars = false;
        this.structuredMedian = STRUCTURED_MEDIAN;
        this.structuredItems = [];
        this.service = "mapy";
        this.isResponsive = false;
        this.curRating = this.rating;
    }
    onRatingChange(rating) {
        this.curRating = rating;
    }
    componentWillLoad() {
        __classPrivateFieldSet(this, _MapyReviewDialogPageStarsStructured_lang, getLocale(this.hostElement), "f");
        this.curRating = this.rating;
        __classPrivateFieldSet(this, _MapyReviewDialogPageStarsStructured_wasStarsClick, this.rating > 0, "f");
    }
    render() {
        const starsArea = h("div", { key: '015e96bea96e4f230e279ed0688bd379bc689eb4', class: classNames(["stars-area", this.hasButton && this.loading ? "has-loader" : ""]) }, h("mapy-review-stars", { key: 'db729194bbf2c1989b3da1787b8fa34d9ca8ff5f', value: this.curRating, size: this.isResponsive ? STARS_SIZE.responsive : STARS_SIZE.normal, onInput: this.onStarsChange, gap: 13, disabled: this.loading }), !this.hasButton && this.loading && h("div", { key: 'a7dacb0a1b7159076fd88f9345226dee074b63a6', class: "areaLoader" }, h("mapy-loader", { key: '5d5f0fb61763bb140e874e5788ec0aa20dc0ebd2' })));
        const structuredArea = this.structuredItems.length > 0 && h("div", { key: '8af7a2773509d8a79e52f03990c7d9219e10cec5', class: "structuredReview" }, h("mapy-review-structured-review", { key: '989eb62fe37923099d29210f1f8ddd50068b1e66', items: this.structuredItems, onChange: this.onStructuredItemsChange, tooltip: true, lang: __classPrivateFieldGet(this, _MapyReviewDialogPageStarsStructured_lang, "f") }));
        return h(Host, { key: 'bdc647270c4f3de3bddfae019b8ca69bd4a3f7d6' }, h("div", { key: '5bad35ee6bceff27c009392a6f2fc074b0d99b77', class: "mapy-review-dialog-page-stars-structured", "data-theme": getTheme(this.service) }, h("div", { key: '91fd8bc2d79c595bbf72c0e78b860bf860e3ef4a', class: "header" }, h("h3", { key: 'b458277cd4c5e42f1c338edb18043a3e006de887', class: "title" }, this.poiTitle), h("mapy-review-user", { key: '4643a12270865a6f76c685a81705171f7e7f27cc', user: this.user, verifiedUser: this.verifiedUser, onSignal: this.onSignal, lang: __classPrivateFieldGet(this, _MapyReviewDialogPageStarsStructured_lang, "f") })), this.switchStars ? starsArea : structuredArea, this.switchStars ? structuredArea : starsArea, h("mapy-review-dialog-footer", { key: '796460553c9a3389049bb40e2b923468e25d182b', isFirm: this.isFirm, hasButton: this.hasButton, loading: this.hasButton && this.loading, disabled: this.curRating === 0 || this.loading, onSave: this.onFooterSave, onSignal: this.onSignal, error: this.error, lang: __classPrivateFieldGet(this, _MapyReviewDialogPageStarsStructured_lang, "f"), service: this.service })));
    }
    get hostElement() { return this; }
    static get watchers() { return {
        "rating": ["onRatingChange"]
    }; }
    static get style() { return MapyReviewDialogPageStarsStructuredStyle0; }
}, [1, "mapy-review-dialog-page-stars-structured", {
        "user": [513],
        "verifiedUser": [516, "verified-user"],
        "poiTitle": [513, "poi-title"],
        "isFirm": [516, "is-firm"],
        "hasButton": [516, "has-button"],
        "rating": [514],
        "error": [513],
        "loading": [516],
        "switchStars": [516, "switch-stars"],
        "structuredMedian": [514, "structured-median"],
        "structuredItems": [16],
        "service": [513],
        "isResponsive": [516, "is-responsive"],
        "curRating": [32]
    }, undefined, {
        "rating": ["onRatingChange"]
    }]);
_MapyReviewDialogPageStarsStructured_structuredData = new WeakMap(), _MapyReviewDialogPageStarsStructured_wasStarsClick = new WeakMap(), _MapyReviewDialogPageStarsStructured_lang = new WeakMap();
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["mapy-review-dialog-page-stars-structured", "mapy-icon", "mapy-loader", "mapy-review-button", "mapy-review-dialog-footer", "mapy-review-stars", "mapy-review-structured-review", "mapy-review-structured-review-item", "mapy-review-tooltip", "mapy-review-user"];
    components.forEach(tagName => { switch (tagName) {
        case "mapy-review-dialog-page-stars-structured":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, MapyReviewDialogPageStarsStructured);
            }
            break;
        case "mapy-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$a();
            }
            break;
        case "mapy-loader":
            if (!customElements.get(tagName)) {
                defineCustomElement$9();
            }
            break;
        case "mapy-review-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$8();
            }
            break;
        case "mapy-review-dialog-footer":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "mapy-review-stars":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "mapy-review-structured-review":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "mapy-review-structured-review-item":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "mapy-review-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "mapy-review-user":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
defineCustomElement();

export { MapyReviewDialogPageStarsStructured as M, defineCustomElement as d };

//# sourceMappingURL=mapy-review-dialog-page-stars-structured2.js.map